import type { RowProps as BSRowProps } from 'react-bootstrap'

import { Row as BSRow } from 'react-bootstrap'
import styled from 'styled-components'

import { elementStyle } from 'styles/element-style'

export interface RowProps extends BSRowProps, IElement {
  children?: React.ReactNode
}

const StyledRow = styled(BSRow)`
  ${elementStyle}
`

export const Row: React.FC<RowProps> = (props: RowProps) => <StyledRow {...props} />
